export const theme = {
  colors: {
    primary: '#98FB98', // Pastel Green
    primaryDark: '#7BC67B', // Darker shade of Pastel Green
    secondary: '#2196F3', // Blue
    secondaryDark: '#1976D2',
    background: '#1C1C1C',
    surface: '#2C2C2C',
    border: 'rgba(255, 255, 255, 0.1)',
    text: '#FFFFFF',
    textDim: 'rgba(255, 255, 255, 0.6)',
    success: '#98FB98', // Changed to match primary
    error: '#F44336'
  },
  fonts: {
    primary: "'Montserrat', sans-serif"
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  },
  typography: {
    nav: {
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    heading: {
      fontSize: '24px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    body: {
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.02em'
    },
    small: {
      fontSize: '12px',
      fontWeight: 400,
      letterSpacing: '0.02em'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  }
}; 